import React from 'react';
import PropTypes from 'prop-types';
import ordinal from 'ordinal-js';

function RankingCellRenderer(props) {
  const { rowIndex } = props;
  const order = rowIndex + 1;
  return (
    <div style={{ paddingRight: 15 }}>
      {order}<sup>{ordinal.ordinalSuffix(order)}</sup>
    </div>
  );
}

RankingCellRenderer.propTypes = {
  rowIndex: PropTypes.number,
};
RankingCellRenderer.defaultProps = {
  rowIndex: 0,
};

export default RankingCellRenderer;
